export default __webpack_public_path__ + "static/media/Question.eedc2701.svg";